import { useEffect, useState } from "react";
import Lenis from "lenis";
import { api } from "@/lib/api";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { EcosystemSection } from "@/components/landing/EcosystemSection";
import { ExcerptReader } from "@/components/landing/ExcerptReader";
import { Benefits } from "@/components/landing/Benefits";
import { PercorsiSection } from "@/components/landing/PercorsiSection";
import { Testimonials } from "@/components/landing/Testimonials";
import { ShareSection } from "@/components/landing/ShareSection";
import { TelegramCta } from "@/components/landing/TelegramCta";
import { AuthorSection } from "@/components/landing/AuthorSection";
import { Faq } from "@/components/landing/Faq";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  const [content, setContent] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    api.get("/content")
      .then((r) => setContent(r.data))
      .catch(() => setError(true));
    api.post("/track/visit").catch(() => {});
  }, []);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream px-4 text-center" data-testid="landing-error">
        <p className="font-display text-lg text-stone-600">Ops, qualcosa non ha funzionato. Ricarica la pagina per riprovare.</p>
      </div>
    );
  }

  if (!content) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream" data-testid="landing-loading">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-sand border-t-terracotta" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-cream" data-testid="landing-page">
      <Header content={content} />
      <main>
        <Hero content={content} />
        <Marquee />
        <EcosystemSection content={content} />
        <ExcerptReader content={content} />
        <Benefits content={content} />
        <PercorsiSection />
        <Testimonials content={content} />
        <ShareSection content={content} />
        <TelegramCta />
        <AuthorSection content={content} />
        <Faq content={content} />
      </main>
      <Footer content={content} />
    </div>
  );
}
